// src/components/FooterCompact.jsx
import React from "react";
import { Link } from "react-router-dom";

/**
 * Compact footer for auth/login/start pages
 * - Shows only copyright + disclaimer/terms/privacy links
 * - Uses shared linkCls styles for consistent link behavior
 */
export default function FooterCompact() {
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-app bg-app text-app">
      <div className="mx-auto max-w-5xl px-4 py-4 flex flex-col items-center gap-2 sm:flex-row sm:justify-between">
        <div className="text-xs text-muted">
          ©{year} Core2tek LLC. All rights reserved.
        </div>
        <nav className="flex gap-4 text-xs">
          <Link to="/terms" className="linkCls">
            Terms of Service
          </Link>
          <Link to="/kb/support" className="linkCls">
            Contact Us
          </Link>
        </nav>
      </div>
    </footer>
  );
}
